import { type AsideItem } from "../types";
import { Link } from "react-router";
import ExternalLinkIcon from "../../../../assets/icons/lucide/ExternalLinkIcon";

// Spec 20261028-130000 AC-7: the name a screen reader hears for an item that leaves the portal.
const accessibleName = (item: AsideItem) => (item.external ? `${item.content} (abre outro sistema)` : item.content);

const MenuItem = ({
  pathname,
  asideItems,
  searchable,
}: { pathname: string; asideItems: AsideItem[]; searchable?: boolean | undefined }) => {

  const filteredAsideItems = asideItems.filter(
    (asideItem) =>
      asideItem.href || asideItem.onClick || (!asideItem.href && asideItem.dropdown?.length !== 0),
  );

  return (
    <ul>
      {searchable && asideItems.length > 0 && (
        <li
          children={
            <input
              type="text"
              name="search"
              placeholder="Buscar"
            />
          }
        />
      )}
      {filteredAsideItems.map((asideItem, index) => {
        const isActive = asideItem.href ? pathname.startsWith(asideItem.href) : false;

        const inner = (
          <>
            {asideItem.icon && <i>{asideItem.icon}</i>}
            <span>{asideItem.content}</span>
            {asideItem.external && (
              <ExternalLinkIcon className="external-mark" width={12} height={12} aria-hidden="true" data-testid="external-mark" />
            )}
          </>
        );

        return (
          <li
            onClick={asideItem.onClick && !asideItem.href ? asideItem.onClick : undefined}
            key={index}
            className={`${asideItem.classname ?? ""} ${isActive ? "--active" : ""} ${asideItem.dropdown ? "--is_dropdown" : ""} ${asideItem.groupStart ? "--group_start" : ""}`}
            style={{ borderRadius: asideItem.content === "Sair" ? " 0 0 1rem 0" : "" }}
          >
            {asideItem.href ? (
              <Link to={asideItem.href} title={accessibleName(asideItem)} aria-label={accessibleName(asideItem)}>
                {inner}
              </Link>
            ) : asideItem.onClick ? (
              // `role="button"` obriga a tratar Enter E Espaço na mão (WAI-ARIA APG). Só o Enter
              // estava tratado, então quem navega por teclado não conseguia acionar Agendamento,
              // Gestão Atendimento, NTO - Flow, Novo Relatório nem Relatório.
              // ponytail: continua `<a>` porque ~14 seletores de `style.ts` casam com `li > a`;
              // trocar o elemento é o conserto de raiz e vem junto com essa varredura de CSS.
              <a
                role="button"
                tabIndex={0}
                title={accessibleName(asideItem)}
                aria-label={accessibleName(asideItem)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault(); // Espaço rolaria a página
                    asideItem.onClick!();
                  }
                }}
              >
                {inner}
              </a>
            ) : (
              <a role="button" tabIndex={0} title={accessibleName(asideItem)} aria-label={accessibleName(asideItem)}>
                {inner}
              </a>
            )}
            {asideItem.dropdown && (
              <MenuItem
                pathname={pathname}
                asideItems={asideItem.dropdown}
                searchable={asideItem.searchable}
              />
            )}
          </li>
        );
      })}
    </ul>
  );
};

export default MenuItem;
